import moment from "moment";

export const inputHeight = { height: "44px" };
export const verifyButtonStyle = {
  position: "absolute",
  right: "10px",
  right: "10px",
  bottom: "0px",
};
// ─── Vendor Type dropdown (example - will come from master) ──────────
export const vendorTypeDropdown = [
  { label: "Admission Advisor", value: "ADMISSION_ADVISOR" },
  // { label: "Contractor", value: "CONTRACTOR" },
  // { label: "Consultant", value: "CONSULTANT" },
  // { label: "Supplier", value: "SUPPLIER" },
  { label: "Invigilator", value: "INVIGILATOR" },
];

export const bankAccountTypes = [
  { label: "Savings", value: "Savings" },
  { label: "Current", value: "Current" },
];

export const withholdingTaxTypeDropdown = [
  { label: "206C TCS - INVOICE", value: "TI" },
  { label: "TDS Recoverable", value: "TR" },
  { label: "194A - INVOICE", value: "AI" },
  { label: "194A - PAYMENT", value: "AP" },
  { label: "194C - INVOICE", value: "CI" },
  { label: "194C - PAYMENT", value: "CP" },
  { label: "Exempted - Invoice", value: "EI" },
  { label: "Exempted - Payment", value: "EP" },
  { label: "195 - INVOICE", value: "FI" },
  { label: "195 - PAYMENT", value: "FP" },
  { label: "393(1)(1)(ii) - INVOICE", value: "HI" },
  { label: "194H - PAYMENT", value: "HP" },
  { label: "194I - INVOICE", value: "II" },
  { label: "194I - PAYMENT", value: "IP" },
  { label: "194J - INVOICE", value: "JI" },
  { label: "194J - PAYMENT", value: "JP" },
];

export const receiptTypes = [
  { label: "Other", value: "other" },
  {
    label: "Company",
    value: "company",
  },
];

// ─── Occupation dropdown ─────────────────────────────────────────────
export const occupationDropdown = [
  {
    label: "Principal/Director/President",
    value: "PRINCIPAL_DIRECTOR_PRESIDENT",
  },
  { label: "Professor/Lecturer", value: "PROFESSOR_LECTURER" },
  { label: "School Owner", value: "SCHOOL_OWNER" },
  { label: "School Clerk/Admin", value: "SCHOOL_CLERK_ADMIN" },
  { label: "Teacher", value: "TEACHER" },
  {
    label: "School Coordinator/Counsellor",
    value: "SCHOOL_COORDINATOR_COUNSELLOR",
  },
  { label: "Tution Teacher", value: "TUTION_TEACHER" },
  { label: "Social Worker", value: "SOCIAL_WORKER" },
  { label: "Education Consultant", value: "EDUCATION_CONSULTANT" },
  { label: "Ex-Employee of Competitor", value: "EX_EMPLOYEE_OF_COMPETITOR" },
  { label: "College Coordinator", value: "COLLEGE_COORDINATOR" },
  { label: "LIC Agent", value: "LIC_AGENT" },
  { label: "Cab Driver", value: "CAB_DRIVER" },
  { label: "Doctor", value: "DOCTOR" },
  { label: "Housewife", value: "HOUSEWIFE" },
  { label: "Farmer", value: "FARMER" },
  { label: "Other", value: "OTHER" },
];

// ─── Agreement type dropdown ─────────────────────────────────────────
export const agreementTypeDropdown = [
  { label: "Agreement", value: "AGREEMENT" },
  { label: "Other details", value: "OTHER_DETAILS" },
];

// ─── Initial form state ──────────────────────────────────────────────
export const getVendorFormInitialState = (modalData = {}) => {
  const withHoldingTaxTypeData =
    modalData?.vendorType?.value === "ADMISSION_ADVISOR"
      ? { label: "393(1)(1)(ii) - INVOICE", value: "HI" }
      : { label: "Exempted - Payment", value: "EP" };

  const withholdingTaxCodeData = modalData?.vendorType?.value === "ADMISSION_ADVISOR" ? "H6" : "EE";

  return {
    // Section 1 – Vendor Details (pre-filled from modal)
    vendorType: modalData?.vendorType || null,
    panCardNumber: modalData?.panCardNumber || "",
    sapVendorId: "", // blank - filled by SAP after L4 approval
    approvalStatus: "", // blank - filled by approval workflow
    onboardingDate: null,

    // Section 2 – Basic Information
    firstName: "",
    lastName: "",
    emailId: "",
    mobileNumber: "",
    language: null,
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    addressLine4: "",
    pincode: null, // searchable dropdown from pincode master
    city: "", // auto-filled from pincode
    state: "", // auto-filled from pincode
    country: "", // auto-filled from pincode
    occupation: null,
    occupationManualEntry: "", // free text if occupation = OTHER

    organisation: "",
    designation: "",
    gstin: "",

    // Section 3 – Onboarding Details
    buCode: null, // searchable dropdown from BU Code master
    sapPlantId: "", // auto-filled from buCode
    employeeId: "", // auto-filled from logged-in user
    employeeName: "", // auto-filled from employeeId
    employeeDesignation: "", // auto-filled from employeeId

    // Section 4 – Reference Details (optional)
    referenceEmployeeId: null, // searchable dropdown
    referenceEmployeeName: "", // auto-filled
    referenceDesignation: "", // auto-filled

    // Section 5 – Payments and Tax
    preferredPaymentMethod: null,
    bankCode: null,
    bankBranch: "",
    accountHolderName: "",
    accountNumber: "",
    ifscCode: "",
    accountType: null,

    // Section 6 – Withholding Tax Data
    withholdingTitle: "Company",
    withholdingTaxType: withHoldingTaxTypeData,
    withholdingTaxCode: withholdingTaxCodeData,
    defaultJurisdiction: "Withholding Applicable",
    recipientType: { label: "Others", value: "Others" },
    paymentTerm: "K028",
    accountGroup: "Z003",
    vendorClass: "0",

    // Section 7 – Agreements
    agreements: [],
  };
};

// ─── PAN validation ──────────────────────────────────────────────────
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const validatePan = (pan) => PAN_REGEX.test(pan?.toUpperCase());

// ─── GSTIN validation ────────────────────────────────────────────────
export const GSTIN_REGEX =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const validateGstin = (gstin) =>
  !gstin || GSTIN_REGEX.test(gstin?.toUpperCase());

// ─── IFSC validation ─────────────────────────────────────────────────
export const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const validateIfsc = (ifsc) => IFSC_REGEX.test(ifsc?.toUpperCase());

// ─── Email validation ────────────────────────────────────────────────
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const validateEmail = (email) => EMAIL_REGEX.test(email);

// ─── Section-level validation ────────────────────────────────────────
export const validateSection1 = (form) =>
  form?.vendorType?.value && form?.panCardNumber && form?.onboardingDate;

export const validateSection2 = (form) =>
  form?.firstName?.trim() &&
  form?.lastName?.trim() &&
  validateEmail(form?.emailId) &&
  form?.mobileNumber?.length === 10 &&
  form?.language?.value &&
  form?.addressLine1?.trim() &&
  form?.pincode?.value &&
  form?.occupation?.value &&
  form?.organisation?.trim() &&
  form?.designation?.trim();

export const validateSection3 = (form) =>
  form?.buCode?.value && form?.employeeId;

export const validateSection5 = (form) =>
  form?.preferredPaymentMethod?.value &&
  form?.bankCode?.value &&
  form?.bankBranch?.trim() &&
  form?.accountHolderName?.trim() &&
  form?.accountNumber &&
  validateIfsc(form?.ifscCode) &&
  form?.accountType?.value;

export const validateAgreements = (agreements) => agreements?.length > 0;

export const validateFullForm = (form) =>
  validateSection1(form) &&
  validateSection2(form) &&
  validateSection3(form) &&
  validateSection5(form) &&
  validateAgreements(form?.agreements);

// ─── Build API request payload ───────────────────────────────────────
// Flattens form state into the shape your backend expects.
// Adjust field names here to match your actual API contract.
// ─── Build API request payload ───────────────────────────────────────
// Maps form state to exact API field names from the create vendor endpoint
export const buildVendorPayload = (form) => ({
  // Section 1 – Vendor Details
  vendorType: form?.vendorType?.value || null,
  panNumber: form?.panCardNumber || null,
  onboardingDate: form?.onboardingDate
    ? new Date(form.onboardingDate).toISOString()
    : null,

  // Section 2 – Basic Information
  vendorFirstName: form?.firstName || null,
  vendorLastName: form?.lastName || null,
  emailId: form?.emailId || null,
  phoneNumber: form?.mobileNumber || null,
  lang: form?.language?.value || null,
  addressLine1: form?.addressLine1 || null,
  addressLine2: form?.addressLine2 || null,
  addressLine3: form?.addressLine3 || null,
  addressLine4: form?.addressLine4 || null,
  pincode: form?.pincode || null,
  city: form?.city?.label || form?.city || null,
  state: form?.state?.label || form?.state || null,
  country: form?.country?.label || form?.country || null,
  occupation:
    form?.occupation?.value === "OTHER"
      ? form?.occupationManualEntry || null
      : form?.occupation?.value || null,
  organization: form?.organisation || null,
  designation: form?.designation || null,
  gstin: form?.gstin || null,

  // Section 3 – Onboarding Details
  onboardingBusinessAreaId: form?.buCode?.value || null,
  onboardingBusinessAreaDispVal: form?.buCode?.label || null,
  onboardingSapPlantCode: form?.sapPlantId || null,
  onboardingCostCode: form?.buCode?.costCode || null,
  onboardingEmployeeId: form?.employeeId || null,
  onboardingEmployeeName: form?.employeeName || null,
  onboardingEmployeeDesignation: form?.employeeDesignation || null,

  // Section 4 – Reference Details
  referenceEmployeeId: form?.referenceEmployeeId || null,
  referenceEmployeeName: form?.referenceEmployeeName || null,
  referenceEmployeeDesignation: form?.referenceDesignation || null,

  // Section 5 – Payments and Tax
  preferredPaymentMethod: form?.preferredPaymentMethod?.value || null,
  bankName: form?.bankCode?.label || null,
  bankBranch: form?.bankBranch || null,
  accountHolderName: form?.accountHolderName || null,
  bankAccount: form?.accountNumber || null,
  ifsc: form?.ifscCode || null,
  accountType: form?.accountType?.value || null,

  // Section 6 – Withholding Tax Data
  withholdingTaxTitle: form?.withholdingTitle || null,
  withholdingTaxType: form?.withholdingTaxType?.value || null,
  withholdingTaxCode: form?.withholdingTaxCode || null,
  withholdingTaxDefaultJurisdiction: form?.defaultJurisdiction || null,
  withholdingTaxRecipientType: form?.recipientType?.value || null,
  withholdingPaymentTerm: form?.paymentTerm || null,
  withholdingAccountGroup: form?.accountGroup || null,
  withholdingVendorClass: form?.vendorClass || null,

  // Status
  status: "SUBMITTED",

  // Section 7 – Agreements → attachments array
  attachments: (form?.agreements || []).map((a) => ({
    attachmentType: a?.type?.value === "AGREEMENT" ? "AGREEMENT" : "OTHER",
    attachmentKey: a?.attachmentKey || null,
    attachmentName: a?.attachmentName || null,
    effectiveDate: a?.effectiveDate
      ? new Date(a.effectiveDate).toISOString()
      : null,
    expiryDate: a?.expiryDate ? new Date(a.expiryDate).toISOString() : null,
  })),
});

export const findUserRole = (roleId, rolesDropdown = []) => {
  if (!roleId || rolesDropdown.length === 0) return "";

  const userRole = rolesDropdown.find((role) => role.value === roleId);
  if (userRole) {
    return userRole?.label;
  }
  return "";
};

export const mapApiResponseToForm = (data, dropdowns = {}) => {
  const dd = dropdowns || {};

  // Find dropdown option by value OR by id
  const findOpt = (list, val) =>
    list?.find(
      (o) => String(o?.value) === String(val) || String(o?.id) === String(val),
    ) || null;

  // Build option from raw value if not found in dropdown list
  const optOrRaw = (list, val, label) =>
    findOpt(list, val) || (val ? { label: label || val, value: val } : null);

  return {
    // ── Section 1 – Vendor Details ──────────────────────────────────
    vendorType: optOrRaw(
      vendorTypeDropdown,
      data?.vendorType,
      data?.vendorType,
    ),
    panCardNumber: data?.panNumber || "",
    sapVendorId: data?.vendorSapCode || "",
    approvalStatus: data?.status || "",
    onboardingDate: data?.onboardingDate
      ? moment(data.onboardingDate).format("DD-MMM-YYYY")
      : "",

    // ── Section 2 – Basic Information ──────────────────────────────
    firstName: data?.vendorFirstName || "",
    lastName: data?.vendorLastName || "",
    emailId: data?.emailId || "",
    mobileNumber: data?.phoneNumber || "",
    // lang is an ID — match against dropdown
    language: optOrRaw(dd.languages, data?.lang, data?.lang),
    addressLine1: data?.addressLine1 || "",
    addressLine2: data?.addressLine2 || "",
    addressLine3: data?.addressLine3 || "",
    addressLine4: data?.addressLine4 || "",
    pincode: data?.pincode || "",
    // city/state/country are IDs — match against dropdown
    city: optOrRaw(dd.cities, data?.city, data?.city),
    state: optOrRaw(dd.states, data?.state, data?.state),
    country: optOrRaw(dd.countries, data?.country, data?.country),
    // occupation — check if value exists in static dropdown
    occupation: optOrRaw(
      occupationDropdown,
      data?.occupation,
      data?.occupation,
    ),
    // if occupation not in static list, treat as "OTHER" + put in manual entry
    occupationManualEntry: occupationDropdown.find(
      (o) => o.value === data?.occupation,
    )
      ? ""
      : data?.occupation || "",
    organisation: data?.organization || "",
    designation: data?.designation || "",
    gstin: data?.gstin || "",

    // ── Section 3 – Onboarding Details ─────────────────────────────
    buCode: data?.onboardingBusinessAreaId
      ? optOrRaw(
          dd.buCodes,
          data.onboardingBusinessAreaId,
          data.onboardingBusinessAreaDispVal,
        )
      : data?.onboardingBusinessAreaDispVal
        ? {
            label: data.onboardingBusinessAreaDispVal,
            value: data.onboardingBusinessAreaDispVal,
          }
        : null,
    sapPlantId: data?.onboardingSapPlantCode || "",
    employeeId: data?.onboardingEmployeeId || "",
    employeeName: data?.onboardingEmployeeName || "",
    employeeDesignation: data?.onboardingEmployeeDesignation || "",

    // ── Section 4 – Reference Details ──────────────────────────────
    // referenceEmployeeId is a plain string (e.g. "A16914")
    referenceEmployeeId: data?.referenceEmployeeId || "",
    referenceEmployeeName: data?.referenceEmployeeName || "",
    referenceDesignation: data?.referenceEmployeeDesignation || "",

    // ── Section 5 – Payments and Tax ───────────────────────────────
    preferredPaymentMethod: optOrRaw(
      dd.paymentMethods,
      data?.preferredPaymentMethod,
      data?.preferredPaymentMethod,
    ),
    bankCode: optOrRaw(dd.bankCodes, data?.bankName, data?.bankName),
    bankBranch: data?.bankBranch || "",
    accountHolderName: data?.accountHolderName || "",
    accountNumber: data?.bankAccount || "",
    ifscCode: data?.ifsc || "",
    accountType: optOrRaw(
      bankAccountTypes,
      data?.accountType,
      data?.accountType,
    ),

    // ── Section 6 – Withholding Tax Data ───────────────────────────
    withholdingTitle: data?.withholdingTaxTitle || "",
    // withholdingTaxType is a code like "EP" — matches withholdingTaxTypeDropdown values
    withholdingTaxType:
      findOpt(withholdingTaxTypeDropdown, data?.withholdingTaxType) || null,
    withholdingTaxCode: data?.withholdingTaxCode || "",
    defaultJurisdiction: data?.withholdingTaxDefaultJurisdiction || "",
    recipientType: optOrRaw(
      dd.recipientTypes,
      data?.withholdingTaxRecipientType,
      data?.withholdingTaxRecipientType,
    ),
    paymentTerm: data?.withholdingPaymentTerm || "",
    accountGroup: data?.withholdingAccountGroup || "",
    vendorClass: data?.withholdingVendorClass || "",

    // ── Section 7 – Agreements (attachments array) ──────────────────
    agreements: (data?.attachments || []).map((a) => ({
      type:
        agreementTypeDropdown.find((o) => o.value === a?.attachmentType) ||
        (a?.attachmentType
          ? { label: a.attachmentType, value: a.attachmentType }
          : null),
      effectiveDate: a?.effectiveDate
        ? moment(a.effectiveDate).format("DD-MMM-YYYY")
        : "",
      expiryDate: a?.expiryDate
        ? moment(a.expiryDate).format("DD-MMM-YYYY")
        : "",
      attachmentKey: a?.attachmentKey || "",
      attachmentName: a?.attachmentName || "",
    })),
  };
};

export  const payModeProcessTagTypeMapping=[
    { payMode: 'EFT', tagTypeKey: 'VENDOR' },
    { payMode: 'CHKL', tagTypeKey: 'VENDOR' },
]
export const vendorPayModeUploadDropdown=[
    {label:'EFT', value:'EFT'},
    {label:'CHKL', value:'CHKL'},
]